import React, { FC } from 'react';

import LogIn from 'src/prize/scenes/LogIn';

import { IWebLink } from '../../types';
import Link from './atoms/Link';

import styles from './index.module.sass';

interface LinksProps {
  className?: {
    container?: string;
    item?: string;
    link?: string;
  };
  data?: IWebLink[];
}

const Links: FC<LinksProps> = ({ className, data = [] }) => (
  <ul className={className?.container}>
    <li className={`${className?.item} ${styles.login}`}>
      <LogIn className={className?.link} isMobile />
    </li>
    {data.map(( item ) => (
      <li className={className?.item} key={item.id}>
        <Link className={className?.link} href={item.url}>
          {item.label}
        </Link>
      </li>
    ))}
  </ul>
);

export default Links;
